import { createReducer, on } from '@ngrx/store';
import { ReviewsActions, RouterActions, AppActions, FacebookActions } from '@actions/index'
import { ReviewModel, ReviewPageRequestDescriptor } from '@models/index'

export interface State {
    reviews: ReviewModel[];
    pagesId: (ReviewPageRequestDescriptor & { locationId?: string })[],
    total: number;
    filterTotal: number;
    replyToDelete: string;
    replyToBePosted: {
        reviewId: string,
        reply: string
    };
    error: string;
}

const initialState: State = {
    reviews: [],
    pagesId: [],
    total: 0,
    filterTotal: 0,
    replyToDelete: '',
    replyToBePosted: {
        reviewId: '',
        reply:''
    },
    error: ''
};

export const reducer = createReducer(
    initialState,
    on(ReviewsActions.searchReviewsSuccess, (state, { data, total }) => ({
        ...state,
        reviews: data,
        filterTotal: total,
    })),
    on(ReviewsActions.getPagesIdSuccess, (state, { data }) => ({
        ...state,
        pagesId: data
    })),
    on(ReviewsActions.getTotalReviewsByLocationSuccess, (state, { total }) => ({ ...state, total })),
    on(ReviewsActions.deleteReviewReplySuccess, (state, {data}) => ({ ...state, reviews: state.reviews.map(item=>item.googleReviewId==data.googleReviewId?data:item), replyToDelete: '' })),
    on(ReviewsActions.replyToReviewSuccess, (state, {data}) => ({ ...state, reviews: state.reviews.map(item => item.googleReviewId == data.googleReviewId ? data : item), replyToBePosted: {reviewId: '', reply: ''} })),
    on(ReviewsActions.deleteReviewReply, (state, {request}) => ({ ...state, replyToDelete: request.params.substring(request.params.lastIndexOf('/') + 1, request.params.indexOf('?'))})),
    on(ReviewsActions.replyToReview, (state, {request}) => ({ ...state, replyToBePosted: {reviewId: request.params.substring(request.params.lastIndexOf('/') + 1, request.params.indexOf('?')), reply: request.payload}})),
    on(ReviewsActions.reviewError, (state, { error }) => ({ ...state, error: error })),
    on(RouterActions.navigateAuth, () => ({ ...initialState })),
    on(AppActions.clearState, (state) => {
        return ({ ...state, 
            reviews: [],
            total: 0,
            filterTotal: 0,
        })}),
    on(FacebookActions.updateCommentOnFacebookPostSuccess, (state, { review }) => ({ ...state, reviews: state.reviews.map(item => item.reviewExternId == review.reviewExternId ? review : item)})),
    on(FacebookActions.commentFacebookPostSuccess, (state, {review}) => ({ ...state, reviews: state.reviews.map(item => item.reviewExternId == review.reviewExternId ? review : item)})),
);

export const getReviews = (state: State) => state.reviews;
export const getPagesId = (state: State) => state.pagesId;
export const getTotal = (state: State) => state.total;
export const getFilterTotal = (state: State) => state.filterTotal;
export const getReplyToDelete = (state: State) => state.replyToDelete;
export const getReplyToBePosted = (state: State) => state.replyToBePosted;
export const getError = (state: State) => state.error;
